"use client";

import { useWeb3 } from "logic/components/providers";
import { truncateAddress } from "logic/utils";

import { useConnectedEmail } from "./useConnectedEmail";

/** Display name for the connected borrower. No borrower-name field exists — Privy
 *  login is email-only — so it's derived from the email's local part
 *  ("andrew.smith@x.com" -> "Andrew Smith"), falling back to the wallet address.
 *
 *  `undefined` when there is neither, i.e. nobody is signed in. Callers render
 *  nothing in that case rather than a placeholder name. */
export function useAccountName() {
  const email = useConnectedEmail();
  const {
    account: { address },
  } = useWeb3();

  const local = email?.split("@")[0];

  if (local) {
    return local
      .split(/[._-]+/)
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return address ? truncateAddress(address) : undefined;
}
